var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_508)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 58,
    height: 58,
    rx: 5.94872,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.37179,
    y: 6.37179,
    width: 57.2564,
    height: 57.2564,
    rx: 5.57692,
    stroke: "#001B34",
    strokeWidth: 0.74359
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 34.667C22.6667 27.1246 22.6667 23.3534 25.0091 21.0094C27.3547 18.667 31.1243 18.667 38.6667 18.667C46.2091 18.667 49.9803 18.667 52.3227 21.0094C54.6667 23.355 54.6667 27.1246 54.6667 34.667C54.6667 42.2094 54.6667 45.9806 52.3227 48.323C49.9819 50.667 46.2091 50.667 38.6667 50.667C31.1243 50.667 27.3531 50.667 25.0091 48.323C22.6667 45.9822 22.6667 42.2094 22.6667 34.667Z",
    stroke: "#001B34",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 39.0673L32.524 40.6673L36.3333 36.6673M31 29.734L32.524 31.334L36.3333 27.334",
    stroke: "#001B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3335 30H47.0002M40.3335 39.3333H47.0002",
    stroke: "#001B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_508",
    x: 0.0769234,
    y: 0.0512824,
    width: 75.8462,
    height: 75.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.97436
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(21 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.19eaaa70d0c219acd6948b03b9b19758.svg";
export { ForwardRef as ReactComponent };